import React, { useCallback, useState } from 'react'
import { coursesModalModes } from '../../assets/const'
import { Main, Files } from './ModalTabs'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { createCourse, updateCourse } from '../../actions/courses'
import Modal from '../../components/Modal'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  title: Yup.string().trim().required('Укажите название предмета')
})

// status: "2" — идёт, "1" — закрыт (легаси "0" тоже закрыт)
const emptyCourse = {
  title: '',
  description: '',
  cd: '',
  status: '2',
  alias: '',
  xp_split: '',
  xp_paired: 0,
  xp_sort: '',
  lid: '',
  isindividual: 0,
  isparallelcourse: 0,
  c_edu_direction: '',
  c_culture: '',
  c_competence: '',
  ege: 0,
  gia: 0,
  p352: 0,
  neednt_grades: 0,
  needhomework: 0,
  skip_attestat: 0,
  reporthse: 0,
  osvobojdeniefiz: 0,
  attestattitle: '',
  attestatklass: '',
  report_sort: '',
  sort: ''
}

const toFormValues = (course) => ({
  ...emptyCourse,
  ...Object.fromEntries(
    Object.entries(course).map(([key, value]) => [key, value ?? emptyCourse[key] ?? value])
  ),
  status: Number(course.status) === 2 ? '2' : '1',
  // старый фронт сохранял «Не выбрано» как 0 — приводим к пустому значению селекта
  lid: course.lid || '',
  c_edu_direction: course.c_edu_direction || '',
  c_culture: course.c_culture || '',
  c_competence: course.c_competence || '',
  attestatklass: course.attestatklass || '',
})

const toNumberOrNull = (value) => (value === '' || value === null || value === undefined) ? null : Number(value)

// PUT перезаписывает все поля: непереданные затираются дефолтами, поэтому шлём форму целиком
const toPayload = (values) => {
  const { cid, createby, createdate, timestamp, ...form } = values
  return {
    ...form,
    title: form.title.trim(),
    lid: toNumberOrNull(form.lid),
    c_edu_direction: toNumberOrNull(form.c_edu_direction),
    c_culture: toNumberOrNull(form.c_culture),
    c_competence: toNumberOrNull(form.c_competence),
    xp_sort: toNumberOrNull(form.xp_sort),
    report_sort: toNumberOrNull(form.report_sort),
    sort: toNumberOrNull(form.sort),
    attestatklass: toNumberOrNull(form.attestatklass),
  }
}

export default function ModalComponent({ selectedId, closeModal, list, addMode, listParams, infoCreateChange }) {
  const [mode, setMode] = useState('main')
  const dispatch = useDispatch()

  const handleCreateCourse = async (values) => {
    const success = await dispatch(createCourse(toPayload(values), listParams))
    if (success) closeModal()
  }

  const handleUpdateCourse = async (values) => {
    const success = await dispatch(updateCourse(selectedId, toPayload(values), listParams))
    if (success) closeModal()
  }

  const course = list?.find(course => course.cid === selectedId)

  const {
    values,
    errors,
    touched,
    dirty,
    setFieldValue,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode || !course ? emptyCourse : toFormValues(course),
    enableReinitialize: true,
    validationSchema,
    onSubmit: addMode ? handleCreateCourse : handleUpdateCourse
  })

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => {
    if (dirty) setConfirmClose(true)
    else closeModal()
  }, [dirty, closeModal])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const renderTab = () => {
    switch (mode) {
      case 'main': return (
        <Main
          closeModal={closeModal}
          infoCreateChange={infoCreateChange}
          values={values}
          error={error}
          setFieldValue={setFieldValue}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      )
      case 'files': return <Files setMode={setMode} closeModal={closeModal} infoCreateChange={infoCreateChange} />
      default: return null
    }
  }

  return (
    <Modal
      open={!!selectedId || addMode}
      menuItem={mode}
      setMenuItem={setMode}
      menuList={coursesModalModes}
      disabledItems={addMode ? ['files'] : []}
      onClose={handleClose}
      closeOnOverlayClick={true}
      closeOnEsc={true}
    >
      {renderTab()}
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
